var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrosimePanouWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a3878144-84a5-490c-8b7b-1996e7182784",
    "data-name": "grosime_panou",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a50ed081-3db1-48c7-bf55-e3ff2fcdb05e,.b1da2df6-061b-47ee-b8fc-be05a0751d04,.bfdf725c-7ac5-4552-9e86-1219005e5e5e{fill:none;stroke:#fff;}.a50ed081-3db1-48c7-bf55-e3ff2fcdb05e,.b1da2df6-061b-47ee-b8fc-be05a0751d04{stroke-linecap:round;stroke-linejoin:round;}.a50ed081-3db1-48c7-bf55-e3ff2fcdb05e{stroke-width:10px;}.bfdf725c-7ac5-4552-9e86-1219005e5e5e{stroke-miterlimit:10;}.b1da2df6-061b-47ee-b8fc-be05a0751d04{stroke-width:5px;}.baaf15a2-faa2-475b-9a99-4f6896b87404{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grosime_panou_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f867e01b-a83a-4c5a-86dc-c4a278f02625",
    "data-name": "sticla_2 copy"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a50ed081-3db1-48c7-bf55-e3ff2fcdb05e",
    x: 77,
    y: 5,
    width: 45,
    height: 190
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 77,
    y1: 171.5,
    x2: 122,
    y2: 28.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 122,
    y1: 20.64,
    x2: 77,
    y2: 126.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 122,
    y1: 58.68,
    x2: 77,
    y2: 186.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 122,
    y1: 80.38,
    x2: 82,
    y2: 194.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 77,
    y1: 88.3,
    x2: 90.1,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 101.33,
    y1: 5,
    x2: 76,
    y2: 87.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 122,
    y1: 13.23,
    x2: 79,
    y2: 96.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 114,
    y1: 5.5,
    x2: 79,
    y2: 80.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 122,
    y1: 160.3,
    x2: 111.8,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 122,
    y1: 149.32,
    x2: 106.18,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 123,
    y1: 137.5,
    x2: 98,
    y2: 194.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 122,
    y1: 126.09,
    x2: 95,
    y2: 194.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "bfdf725c-7ac5-4552-9e86-1219005e5e5e",
    x1: 123,
    y1: 111.5,
    x2: 88,
    y2: 192.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b2fd0aac-f70f-402c-94d1-0350256f5087",
    "data-name": "Arrow copy 4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b1da2df6-061b-47ee-b8fc-be05a0751d04",
    x1: 2.5,
    y1: 100,
    x2: 67.29,
    y2: 100
  }), /*#__PURE__*/React.createElement("path", {
    className: "baaf15a2-faa2-475b-9a99-4f6896b87404",
    d: "M43.87,116.8a1.75,1.75,0,0,1,.54-2.42L67,100,44.41,85.62a1.75,1.75,0,0,1-.54-2.42,1.77,1.77,0,0,1,2.42-.54l24.9,15.86a1.76,1.76,0,0,1,0,3l-24.9,15.86a1.79,1.79,0,0,1-.94.27A1.77,1.77,0,0,1,43.87,116.8Z",
    transform: "translate(-0.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b1da2df6-061b-47ee-b8fc-be05a0751d04",
    x1: 196.5,
    y1: 100,
    x2: 131.71,
    y2: 100
  }), /*#__PURE__*/React.createElement("path", {
    className: "baaf15a2-faa2-475b-9a99-4f6896b87404",
    d: "M156.13,83.2a1.75,1.75,0,0,1-.54,2.42L133,100l22.58,14.38a1.75,1.75,0,0,1,.54,2.42,1.77,1.77,0,0,1-2.42.54l-24.9-15.86a1.76,1.76,0,0,1,0-3l24.9-15.86a1.79,1.79,0,0,1,.94-.27A1.77,1.77,0,0,1,156.13,83.2Z",
    transform: "translate(-0.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrosimePanouWhite);
export default __webpack_public_path__ + "static/media/grosime_panou_white.23da36bd1d409fc8dee44f6b85dd97ea.svg";
export { ForwardRef as ReactComponent };